import { render, staticRenderFns } from "./YuukyuuView.vue?vue&type=template&id=4c6d68bb&scoped=true"
import script from "./YuukyuuView.vue?vue&type=script&lang=js"
export * from "./YuukyuuView.vue?vue&type=script&lang=js"
import style0 from "./YuukyuuView.vue?vue&type=style&index=0&id=4c6d68bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6d68bb",
  null
  
)

export default component.exports